import React from 'react';

export default function GradientBackground() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* Base warm wash */}
      <div className="absolute inset-0 bg-[hsl(35,40%,95%)]" />

      {/* Top-left yellow/orange blob */}
      <div
        className="absolute -top-[20%] -left-[15%] w-[65%] h-[70%] rounded-full opacity-50"
        style={{
          background: 'radial-gradient(circle, hsl(42, 100%, 82%) 0%, hsl(35, 90%, 85%) 40%, transparent 70%)',
        }}
      />

      {/* Center pink wash */}
      <div
        className="absolute top-[15%] left-[20%] w-[70%] h-[60%] rounded-full opacity-30"
        style={{
          background: 'radial-gradient(circle, hsl(330, 80%, 88%) 0%, transparent 65%)',
        }}
      />

      {/* Bottom-right magenta blob */}
      <div
        className="absolute -bottom-[10%] -right-[10%] w-[55%] h-[60%] rounded-full opacity-40"
        style={{
          background: 'radial-gradient(circle, hsl(315, 75%, 85%) 0%, hsl(330, 60%, 90%) 35%, transparent 65%)',
        }}
      />

      {/* Top-right subtle lilac */}
      <div
        className="absolute -top-[5%] right-[5%] w-[35%] h-[40%] rounded-full opacity-25"
        style={{
          background: 'radial-gradient(circle, hsl(280, 50%, 88%) 0%, transparent 60%)',
        }}
      />

      {/* Bottom-left warm glow */}
      <div
        className="absolute bottom-[5%] -left-[5%] w-[40%] h-[35%] rounded-full opacity-30"
        style={{
          background: 'radial-gradient(circle, hsl(30, 90%, 87%) 0%, transparent 60%)',
        }}
      />
    </div>
  );
}
